import React from 'react';
import Select from './Select'
import update from 'immutability-helper';
import ReactResponsiveSelect from 'react-responsive-select';

const caretIcon = (
    <svg className="caret-icon" x="0px" y="0px" width="11.848px" height="6.338px" viewBox="351.584 2118.292 11.848 6.338">
        <g><path d="M363.311,2118.414c-0.164-0.163-0.429-0.163-0.592,0l-5.205,5.216l-5.215-5.216c-0.163-0.163-0.429-0.163-0.592,0s-0.163,0.429,0,0.592l5.501,5.501c0.082,0.082,0.184,0.123,0.296,0.123c0.103,0,0.215-0.041,0.296-0.123l5.501-5.501C363.474,2118.843,363.474,2118.577,363.311,2118.414L363.311,2118.414z"/></g>
    </svg>
);

const multiSelectOptionMarkup = (text) => (
    <div>
        <span className="checkbox">
            <svg className="checkbox-icon" x="0px" y="0px" width="12px" height="12px" viewBox="0 0 488.878 488.878">
                <g><polygon points="143.294,340.058 50.837,247.602 0,298.439 122.009,420.447 122.149,420.306 144.423,442.58 488.878,98.123 437.055,46.298 "/></g>
            </svg>
        </span>
        <span> {text}</span>
    </div>
);

function Conditions(props) {

    function handleChange(value) {
        props.onChange(value);
        //console.log('The link was clicked.');
    }
    if (props.options.length) {
        return (
            <ReactResponsiveSelect
                options={props.options}
                noSelectionLabel={'Select Relation'}
                onChange={handleChange}
                caretIcon={caretIcon}
                selectedValue={props.value}
            />
        );
    } else {
        return false;
    }
}

function PaymentMethods(props) {
    const methods = window.awdp_object.paymentgateways;
    let options = [];
    if (methods) {
        options.push({ text: 'Select Payment Method', value: 'null', markup: multiSelectOptionMarkup('Select Payment Method') })
        for (var key in methods) {
            options.push({ text: methods[key]['title'], value: key, markup: multiSelectOptionMarkup(methods[key]['title']) })
        }
        let value = ((Array.isArray(props.value) && props.value.length) ? props.value : ['0']);
        return (
            <ReactResponsiveSelect
                multiselect={true}
                options={options}
                caretIcon={caretIcon}
                onChange={(value) => {
                    props.onChange(value);
                }}
                selectedValues={value}
            />
        );
    }
}

export default class FormTest extends React.Component {

    constructor(props) {
        super(props);

        let forms = [];

        this.state = {
            data: props.rules
        };
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.rules !== this.props.rules){
            this.setState({data:nextProps.rules});
        }
    }

    handleRemove(event, i, j) {
        let item = null;
        this.setState((prevState) => ({
            data: update(this.state.data, { [i]: { rules: { $unset: [j] } } })
        }), () => {
            this.props.onChange(this.state.data)
        })
    }

    handleGroupRemove(event, i) {
        let item = null;
        this.setState((prevState) => ({
           data: update(this.state.data, { $unset: [i] })
        }), () => {
            this.props.onChange(this.state.data)
        })
    }

    handleAdd(event, i) {
        let item = [{
            "operator": 'AND',
            "rule": {
                "item": "",
                "condition": "",
                "value": ""
            }
        }];

        this.setState((prevState) => ({
             data: update(this.state.data, { [i]: { rules: { $push: item } } })
        }), () => {
            this.props.onChange(this.state.data)
        })
    }

    handleGroupAdd(event, i) {
        let item = [{
            "operator": 'AND',
            "rules": [
                {
                    "operator": 'AND',
                    "rule": {
                        "item": "",
                        "condition": "",
                        "value": ""
                    }
                }
            ]
        }];

        this.setState((prevState) => ({
            data: update(this.state.data, { $push: item })
        }), () => {
            this.props.onChange(this.state.data)
        })
    }

    handleValueChange(event, i, j) {
        let val = event.target.value;
        //    let data = update(this.state.data, { [i]: { rules: { [j]: { rule: { value: { $set: val } } } } }} );
        this.setState((prevState) => ({
         data: update(this.state.data, { [i]: { rules: { [j]: { rule: { value: { $set: val } } } } } })
        }), () => {
            this.props.onChange(this.state.data)
        })
        // console.log('data')
        // console.log(data)
        // this.props.onChange(data)
    }

    handleRelationChange(value, i, j = false) {
        let val = value.value;
        //console.log(val);
        if (j === false) {
            this.setState((prevState) => ({
                data: update(this.state.data, { [i]: { operator: { $set: val } } } )
            }), () => {
                this.props.onChange(this.state.data)
            })
        } else {
            this.setState((prevState) => ({
                 data: update(this.state.data, { [i]: { rules: { [j]: { operator: { $set: val } } } } })
            }), () => {
                this.props.onChange(this.state.data)
            })
        }
    }

    handleCatChange(value, i, j) {
        if (value) {
            let options = value.options.map(e => {
                return e.value;
            });
            //console.log(options);
            this.setState((prevState) => ({
                data: update(this.state.data, { [i]: { rules: { [j]: { rule: { value: { $set: options } } } } } })
            }), () => {
                this.props.onChange(this.state.data)
            })
        }
    }

    handleConditionChange(value, i, j) {
        let item = null;

        if (value) {
            let sub = '';
            // if (item.sub) {
            //     sub = item.sub;
            // }
            // this.setState((prevState) => ({
            //     ...prevState, value: item[0].conditions
            // }))
            this.setState((prevState) => ({
               data: update(this.state.data, { [i]: { rules: { [j]: { rule: { condition: { $set: value.value } } } } } })
            }), () => {
                this.props.onChange(this.state.data)
            })
        }
    }

    handleItemsChange(newvalue, i, j) {
        if (newvalue !== undefined) {

            //this.state.data[i].rules[j].value =  event.target.value;
            let value = newvalue.value;
            this.setState((prevState) => ({
                data: update(this.state.data, { [i]: { rules: { [j]: { rule: { item: { $set: value } } } } } })
            }), () => {
                this.props.onChange(this.state.data)
            })
        }
    }

    render() {
        let render;
        const conditions_set_1 = [
            { text: 'Equal to', value: 'equal_to', sub: { type: 'number' } },
            { text: 'Less than', value: 'less_than', sub: { type: 'number' } },
            { text: 'Less than or Equal', value: 'less_than_eq', sub: { type: 'number' } },
            { text: 'Greater than', value: 'greater_than', sub: { type: 'number' } },
            { text: 'Greater than or Equal', value: 'greater_than_eq', sub: { type: 'number' } }
        ];


        const rules_items = [
            {
                text: 'Select Item',
                value: '',
                conditions: []
            },
            {
                text: 'Product price',
                value: 'product_price',
                conditions: [...conditions_set_1],
            },
            {
                text: 'Cart total amount',
                value: 'cart_total_amount',
                conditions: [...conditions_set_1],
            },
            // {
            //     text: 'Cart items (no. of items in cart)',
            //     value: 'cart_items',
            //     conditions: [...conditions_set_1]
            //
            // },
            // {
            //     text: 'Customer previous order items count',
            //     value: 'cust_prev_order_count',
            //     conditions: [...conditions_set_1]
            //
            // },
            // {
            //     text: 'Payment Method',
            //     value: 'payment_method',
            //     conditions: [
            //         { text: 'IN', value: 'in', sub: { type: 'payment' } },
            //         { text: 'NOT IN', value: 'notin', sub: { type: 'payment' } },
            //     ]
            //
            // }
        ];
        if (this.state.data.length) {

            render = this.state.data.map((e, i) => {
                let temp = [];
                if (e.rules.length) {
                    temp.push(e.rules.map((f, j) => {
                        //console.log(f);
                        if(f != null) {
                            let selected_item = rules_items.filter(option => {
                                return (option.value === f.rule.item);

                            });

                            let conditions = []
                            let value_field = false;
                            if (selected_item && selected_item.length) {
                                conditions = selected_item[0].conditions;
                            }

                            let selected_condition = conditions.filter(option => {
                                return (option.value === f.rule.condition);
                            });

                            if (selected_item.length && selected_item[0].sub) {
                                value_field = selected_item[0].sub;
                            } else if (selected_condition.length && selected_condition[0].sub) {
                                value_field = selected_condition[0].sub;
                            } else {
                                value_field = { type: 'text' };
                            }

                            let value_render = '';
                            if (selected_condition.length) {
                                if (value_field.type == 'text') {
                                    value_render = (
                                        <input type="text" value={f.rule.value} onChange={((event) => {
                                            this.handleValueChange(event, i, j);
                                        })} />
                                    );
                                } if (value_field.type == 'number') {
                                    value_render = (
                                        <input type="number" value={f.rule.value} onChange={((event) => {
                                            this.handleValueChange(event, i, j);
                                        })} />
                                    );
                                } else if (value_field.type == 'select') {
                                    value_render = (
                                        <ReactResponsiveSelect
                                            options={value_field.options}
                                            caretIcon={caretIcon}
                                            noSelectionLabel={'Select Discount Mode'}
                                            selectedValue={f.rule.value}
                                        />

                                    );
                                } else if (value_field.type == 'payment') {
                                    value_render = (
                                        <div><PaymentMethods value={f.rule.value} onChange={(val) => {
                                            this.handleCatChange(val, i, j);
                                        }} /></div>

                                    );
                                }
                            }
                            let relation = '';
                            if (j < (e.rules.length - 1) && e.rules.length > 1) {
                                relation = (
                                    <div className="awdp_relation clearfix">
                                        <ReactResponsiveSelect
                                            options={
                                                [
                                                    { text: 'AND', value: 'AND' },
                                                    { text: 'OR', value: 'OR' }
                                                ]
                                            }
                                            selectedValue={f.operator}
                                            caretIcon={caretIcon}
                                            onChange={(newvalue) => {
                                                this.handleRelationChange(newvalue, i, j)
                                            }}
                                        />
                                    </div>
                                )
                            }

                            return (
                                <div className="awdp_group clearfix">

                                    <div className="awdp_repeat clearfix">
                                        <div className="awdp_onethird">
                                        <ReactResponsiveSelect
                                            options={rules_items}
                                            noSelectionLabel={'Select Discount Mode'}
                                            selectedValue={f.rule.item}
                                            caretIcon={caretIcon}
                                            onChange={(newvalue) => {
                                                this.handleItemsChange(newvalue, i, j)
                                            }}
                                        />

                                    </div>
                                    <div className="awdp_onethird">
                                        <Conditions value={f.rule.condition} onChange={(value) => {
                                            this.handleConditionChange(value, i, j);
                                        }}

                                            options={conditions} />
                                    </div>
                                    <div className="awdp_onethird">
                                        {value_render}
                                    </div>
                                    </div>
                                    {relation}
                                    <button className="awdp_add awdp_remove" onClick={(event) => {
                                        this.handleRemove(event, i, j);
                                    }}></button>
                                </div>
                            );
                            
                            //return temp.reduce((a, b) => {a + b});
                        }
                    }))
                }

                let relation = '';
                if (i < (this.state.data.length - 1) && this.state.data.length > 1) {
                    //console.log(e.operator);
                    relation = (
                        <ReactResponsiveSelect
                            options={
                                [
                                    { text: 'AND', value: 'AND' },
                                    { text: 'OR', value: 'OR' }
                                ]
                            }
                            selectedValue={e.operator}
                            caretIcon={caretIcon}
                            onChange={(newvalue) => {
                                this.handleRelationChange(newvalue, i, false)
                            }}
                        />
                    )
                }

                return (<div class="group">
                    {temp.length != 0 ? temp.reduce((a, b) => { return a + b }) : '' }
                    <div><button className="awdp_add" onClick={(event) => {
                        this.handleAdd(event, i);
                    }}></button></div>

                    <button className="awdp_removegroup" onClick={(event) => {
                        this.handleGroupRemove(event, i);
                    }}>Group Remove</button>

                    {relation}
                </div>);
            });
        }

        return (
            <div>
                {render}
                <button className="awdp_addgroup" onClick={(event) => {
                    this.handleGroupAdd(event);
                }}>Add Group</button>
            </div>
        );
    }
}